import {
    Grid,
    CircularProgress,
    Button,
    Box,
    IconButton,
    Dialog,
    DialogContent,
    DialogActions,
    FormControl,
    FormGroup,
    DialogTitle,
    Divider,
    Checkbox,
    FormControlLabel,
    TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { addOrUpdateGroup, deleteGroup, getAllTeamsWithUsers, getAllWithSubCategories, getUsers, matchUsersToGroup } from '../../../redux/api/userMgt';
import { AccountTreeOutlined, Add, DeleteOutlined, EditOutlined, PeopleOutlined, Search } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { Form, Formik } from 'formik';
import TextInput from '../../../components/common/TextInput';

const Teams = ({ user }) => {
    const defTeam = {
        name: '',
        description: '',
        subCategoryCodes: [],
    };
    const [processing, setProcessing] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(defTeam);
    const { enqueueSnackbar } = useSnackbar();
    const [teams, setTeams] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [users, setUsers] = useState([]);
    const [actionModal, setActionModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [mappingModal, setMappingModal] = useState(false);
    const [userMappingModal, setUserMappingModal] = useState(false);
    const [mapping, setMapping] = useState(false);
    const [categoryFilterValue, setCategoryFilterValue] = useState('');
    const [userFilterValue, setUserFilterValue] = useState('');

    const columns = [
        {
            field: 'sn',
            headerName: 'S/N',
            width: 80,
            sortable: false,
            renderCell: (params) => {
                return <p style={{ margin: 'auto' }}>{(params?.api?.getRowIndex(params?.row?.groupId) || 0) + 1}</p>;
            },
        },
        {
            field: 'action',
            headerName: 'Quick Action',
            width: 150,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <IconButton
                            size="small"
                            color={'primary'}
                            onClick={() => {
                                setSelectedGroup(params?.row || null);
                                setActionModal(true);
                            }}
                            variant="outlined"
                            title={'Edit Team'}
                        >
                            <EditOutlined />
                        </IconButton>

                        <IconButton
                            size="small"
                            color={'info'}
                            onClick={() => {
                                setSelectedGroup(params?.row || null);
                                setMappingModal(true);
                            }}
                            variant="outlined"
                            title={'Map Sub Categories to Team'}
                        >
                            <AccountTreeOutlined />
                        </IconButton>

                        <IconButton
                            size="small"
                            color={'warning'}
                            onClick={() => {
                                setSelectedGroup(params?.row || null);
                                setUserMappingModal(true);
                            }}
                            variant="outlined"
                            title={'Map Users to Team'}
                        >
                            <PeopleOutlined />
                        </IconButton>

                        <IconButton
                            size="small"
                            color={'error'}
                            onClick={() => {
                                setSelectedGroup(params?.row || null);
                                setDeleteModal(true);
                            }}
                            variant="outlined"
                            title={'Delete Team'}
                        >
                            <DeleteOutlined />
                        </IconButton>
                    </div>
                );
            },
        },
        { field: 'name', headerName: 'Team', width: 200 },
        // { field: 'groupType', headerName: 'Group Type', width: 300 },
        { field: 'createdBy', headerName: 'Created By', width: 200 },
        {
            field: 'createdOn',
            headerName: 'Creation Date',
            width: 200,
            valueGetter: (params) => (params?.row?.createdOn ? moment(params?.row?.createdOn).format('DD MMMM, YYYY') : ''),
        },
        {
            field: 'createdTime',
            headerName: 'Creation Time',
            width: 200,
            valueGetter: (params) => (params?.row?.createdOn ? moment(params?.row?.createdOn).format('hh:mm:ss A') : ''),
        },
    ];

    const init = async () => {
        try {
            setProcessing(true);
            const { resultObject } = await getAllWithSubCategories();
            const resp = await getUsers('internal');
            setUsers(resp || []);
            const resTeams = await getAllTeamsWithUsers();
            setTeams(resultObject?.allGroupsAndTheirCorrespondingSubCategories || []);
            setSubCategories(resultObject?.allSubCategories || []);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const submitForm = async (values) => {
        try {
            await addOrUpdateGroup({ ...values, subCategoryCodes: values?.subCategoryVms?.map(({ code }) => code) ?? [] });
            enqueueSnackbar(`Team ${values?.groupId ? 'Updated' : 'Created'} Successfully`);
            init();
            setActionModal(false);
            setSelectedGroup(defTeam);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const deleteTeam = async (values) => {
        try {
            await deleteGroup(selectedGroup?.groupId);
            enqueueSnackbar('Team Deleted Successfully');
            init();
            setDeleteModal(false);
            setSelectedGroup(defTeam);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const handleChange = ({ target }, value) => {
        let subCategoryVms = [...selectedGroup?.subCategoryVms] || [];
        if (value) {
            subCategoryVms.push({ code: target.id });
        } else {
            subCategoryVms = subCategoryVms.filter(({ code }) => code != target.id);
        }
        setSelectedGroup({ ...selectedGroup, subCategoryVms });
    };

    const hasPermission = (code) => {
        return selectedGroup?.subCategoryVms?.map((x) => x?.code)?.indexOf(code) >= 0 ? true : false;
    };

    const handleUserChange = ({ target }, value) => {
        let userVms = [...(selectedGroup?.userVms || [])] || [];
        if (value) {
            userVms.push({ id: target.id });
        } else {
            userVms = userVms.filter(({ id }) => id != target.id);
        }
        setSelectedGroup({ ...selectedGroup, userVms });
    };

    const hasUserSelected = (id) => {
        return selectedGroup?.userVms?.map((x) => x?.id)?.indexOf(id) >= 0 ? true : false;
    };

    const handleMapping = async () => {
        try {
            setMapping(true);

            await addOrUpdateGroup({
                ...selectedGroup,
                subCategoryCodes: selectedGroup?.subCategoryVms?.map(({ code }) => code) || [],
            });
            enqueueSnackbar(`Sub categories mapped successfully`);
            init();
            setMappingModal(false);
            setSelectedGroup(defTeam);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setMapping(false);
        }
    };

    const handleUserMapping = async () => {
        try {
            setMapping(true);

            await matchUsersToGroup({
                ...selectedGroup,
                userIds: selectedGroup?.userVms?.map(({ id }) => id) || [],
            });
            enqueueSnackbar(`User mapped to team successfully`);
            init();
            setUserMappingModal(false);
            setSelectedGroup(defTeam);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setMapping(false);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <PageContainer
            pageTitle="Teams"
            processing={processing}
            buttonComponent={
                <>
                    <Button onClick={() => setActionModal('create')} startIcon={<Add />} variant="contained">
                        Create Team
                    </Button>
                </>
            }
        >
            <Box>
                <div className="paper" style={{ height: 550, width: '100%', textAlign: 'center' }}>
                    <DataGrid
                        className={'center-first-column'}
                        rows={teams}
                        getRowId={(row) => row.groupId}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        disableSelectionOnClick
                        style={{ fontSize: '12px' }}
                    />
                </div>
            </Box>

            <Dialog open={actionModal} maxWidth="lg" PaperProps={{ style: { minWidth: '50vw' } }}>
                <Formik
                    initialValues={{ ...selectedGroup }}
                    enableReinitialize
                    onSubmit={submitForm}
                    validationSchema={Yup.object().shape({
                        name: Yup.string().required('Name is required.'),
                        description: Yup.string().required('Description is required.'),
                    })}
                >
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent>
                                <h4 className="mb-1">{selectedGroup?.groupId ? 'Edit' : 'Create'} Team</h4>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextInput id="name" required label="Name" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="description" multiline required minRows={2} label="Description" />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className="pb-1 pr-1">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        setActionModal(false);
                                        setSelectedGroup(defTeam);
                                    }}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </Button>
                                <Button variant="contained" color={'primary'} type="submit" disabled={isSubmitting}>
                                    {Boolean(isSubmitting) ? <CircularProgress color="inherit" size={15} /> : selectedGroup?.groupId ? 'Edit' : 'Create'}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Dialog open={Boolean(deleteModal)}>
                <h4 className="text-center mt-2 mb-0">Confirm Team Deletion</h4>
                <Formik initialValues={{ ...selectedGroup }} enableReinitialize onSubmit={deleteTeam}>
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent>
                                <Grid container spacing={3} paddingBottom={3}>
                                    <Grid item xs={12}>
                                        Kindly confirm you want to delete team with details below:
                                        <br />
                                        <br />
                                        {/* <b>ID:</b> {values?.id} <br /> */}
                                        <b>Name:</b> {values?.name} <br />
                                        <b>Description:</b> {values?.description} <br />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button
                                            disabled={isSubmitting}
                                            fullWidth
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                setDeleteModal(false);
                                                setSelectedGroup(defTeam);
                                            }}
                                            style={{ marginTop: '.5rem' }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Button disabled={isSubmitting} startIcon={<DeleteOutlined />} color="error" fullWidth variant="contained" type="submit" style={{ marginTop: '.5rem' }}>
                                            {isSubmitting ? <CircularProgress size={15} color="inherit" /> : 'Delete Team'}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Dialog open={mappingModal} maxWidth="lg">
                <DialogTitle className="no-margin m-0 pt-2" style={{ textTransform: 'initial' }}>
                    <span className="m-0 mb-1 d-block">
                        Map Sub-Catgories to Team: <b>{selectedGroup?.name}</b>
                    </span>
                    <TextField
                        value={categoryFilterValue}
                        onChange={(ev) => setCategoryFilterValue(ev?.target?.value || '')}
                        fullWidth
                        placeholder="Search..."
                        inputProps={{
                            style: { padding: '11px 14px', fontSize: '14px' },
                        }}
                        className="mb-0"
                    />
                </DialogTitle>
                <DialogContent
                    style={{
                        height: '500px',
                        width: '600px',
                        padding: '0.5rem 0 0 2rem',
                    }}
                >
                    <FormControl>
                        <FormGroup>
                            {subCategories
                                ?.filter(({ name, categoryName }) => {
                                    if (categoryFilterValue) {
                                        const value = String(categoryFilterValue).toLowerCase();
                                        name = String(name).toLowerCase();
                                        categoryName = String(categoryName).toLowerCase();

                                        return Boolean(name?.includes(value) || categoryName?.includes(value));
                                    } else {
                                        return true;
                                    }
                                })
                                ?.map((category, key) => (
                                    <>
                                        <FormControlLabel
                                            control={<Checkbox checked={hasPermission(category.code)} id={category.code} onChange={handleChange} name={category.name} />}
                                            label={
                                                <p className="m-0">
                                                    {category?.name || ''}
                                                    <br />
                                                    <small>Category: {category?.categoryName || ''}</small>
                                                </p>
                                            }
                                            key={key}
                                        />
                                        <Divider className="mb-05" />
                                    </>
                                ))}
                        </FormGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions style={{ padding: '1rem' }}>
                    <Button
                        disabled={mapping}
                        onClick={() => {
                            setMappingModal(false);
                            setSelectedGroup(defTeam);
                        }}
                        color="secondary"
                        variant="contained"
                    >
                        Cancel
                    </Button>

                    <Button disabled={mapping} onClick={handleMapping} color="primary" variant="contained">
                        {mapping ? <CircularProgress size={15} color="inherit" /> : 'Save Mapping'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={userMappingModal} maxWidth="lg">
                <DialogTitle className="no-margin m-0 pt-2" style={{ textTransform: 'initial' }}>
                    <span className="m-0 mb-1 d-block">
                        Map Users to Team: <b>{selectedGroup?.name}</b>
                    </span>
                    <TextField
                        value={userFilterValue}
                        onChange={(ev) => setUserFilterValue(ev?.target?.value || '')}
                        fullWidth
                        placeholder="Search..."
                        inputProps={{
                            style: { padding: '11px 14px', fontSize: '14px' },
                        }}
                        className="mb-0"
                    />
                </DialogTitle>
                <DialogContent
                    style={{
                        height: '500px',
                        width: '600px',
                        padding: '0.5rem 2rem 0',
                    }}
                >
                    <FormControl className="w-100">
                        <FormGroup>
                            {users
                                ?.filter(({ firstName, email, lastName }) => {
                                    if (userFilterValue) {
                                        const value = String(userFilterValue).toLowerCase();
                                        const firstNameValue = String(firstName).toLowerCase();
                                        const lastNameValue = String(lastName).toLowerCase();
                                        const emailValue = String(email).toLowerCase();

                                        return Boolean(firstNameValue?.includes(value) || lastNameValue?.includes(value) || emailValue?.includes(value));
                                    } else {
                                        return true;
                                    }
                                })
                                ?.map(({ firstName, email, lastName, id }, key) => (
                                    <>
                                        <FormControlLabel
                                            control={<Checkbox checked={hasUserSelected(id)} id={id} onChange={handleUserChange} name={`${lastName} ${firstName}`} />}
                                            label={
                                                <p className="m-0">
                                                    {`${lastName} ${firstName}` || ''}
                                                    <br />
                                                    <small>Email: {email || ''}</small>
                                                </p>
                                            }
                                            key={key}
                                        />
                                        <Divider className="mb-05" />
                                    </>
                                ))}
                        </FormGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions style={{ padding: '1rem' }}>
                    <Button
                        disabled={mapping}
                        onClick={() => {
                            setUserMappingModal(false);
                            setSelectedGroup(defTeam);
                        }}
                        color="secondary"
                        variant="contained"
                    >
                        Cancel
                    </Button>

                    <Button onClick={handleUserMapping} color="primary" variant="contained" disabled={mapping}>
                        {mapping ? <CircularProgress size={15} color="inherit" /> : 'Save Mapping'}
                    </Button>
                </DialogActions>
            </Dialog>
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(Teams);
